/* eslint-disable camelcase */
import React from 'react'
import useSelector from 'hooks/use-selector'
import getShortDeliveryDateLabelShippingSelector from 'modules/shipping/redux/selectors/get-short-delivery-date-label'
import View from 'components/View'

export default function ProductCardDelivery (props) {
  const deliveryLabel = useSelector(getShortDeliveryDateLabelShippingSelector(props))
  // const debugProps = {
  //   props,
  //   deliveryLabel
  // }
  // logUtil('ProductCardDelivery').debug('[start] debugProps=', debugProps)
  return (
    <View className='product-card-delivery'>{deliveryLabel}</View>
  )
}
